import { Trans } from "@lingui/macro";
import { ButtonBudgetSettings } from "../ButtonBudgetSettings";

export const NoBudgetItems = () => (
  <div className="flex flex-col items-center">
    <div className="text-2xl mb-6 mt-4">
      <Trans>You have no budget items</Trans>
    </div>

    <ButtonBudgetSettings />
  </div>
);
